var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-dropzone",style:(_vm.style)},[_c('div',{staticClass:"v-dropzone__textnode"},[_vm._t("instructions",[_vm._v("Drop file here...")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }